import { createSelector } from 'reselect';
import { getActiveContentItem } from './getActiveContentItem';

const getIsActiveLoading = (state) => state.active.loading.content;

export const getIsActiveContentItemLoading = createSelector(
  [
    getActiveContentItem,
    getIsActiveLoading,
  ],
  (activeContentItem, loading) => (loading && !activeContentItem) || !activeContentItem,
);

export const getIsActiveContentItemLoadingRelated = createSelector(
  [
    getActiveContentItem,
    getIsActiveLoading,
  ],
  (activeContentItem, activeLoading) => activeContentItem && activeLoading,
);
